import { CommonModule } from '@angular/common'
import { Component, inject, Input, OnInit } from '@angular/core'
import { MatIcon } from '@angular/material/icon'
import { ActivatedRoute, NavigationEnd, Router, RouterLink } from '@angular/router'
import { filter } from 'rxjs/operators'

interface Breadcrumb {
	label: string
	url: string
}

@Component({
	standalone: true,
	selector: 'feature-pm-breadcrumbs',
	imports: [CommonModule, RouterLink, MatIcon],
	templateUrl: 'breadcrumbs.component.html',
	styleUrls: ['breadcrumbs.component.scss'],
})
export class BreadcrumbsComponent implements OnInit {
	@Input() venueName?: string
	breadcrumbs: Breadcrumb[] = []
	private router = inject(Router)
	private route = inject(ActivatedRoute)

	ngOnInit() {
		this.breadcrumbs = this.buildBreadcrumbs(this.route.root)
		if (this.venueName) {
			this.breadcrumbs.push({
				label: this.venueName,
				url: this.router.url,
			})
		}
		this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe(() => {
			this.breadcrumbs = this.buildBreadcrumbs(this.route.root)
		})
	}

	private buildBreadcrumbs(
		route: ActivatedRoute,
		url: string = '',
		breadcrumbs: Breadcrumb[] = []
	): Breadcrumb[] {
		const children: ActivatedRoute[] = route.children

		if (children.length === 0) return breadcrumbs

		for (const child of children) {
			const routeURL: string = child.snapshot.url.map(segment => segment.path).join('/')
			if (routeURL !== '') {
				url += `/${routeURL}`
			}

			const breadcrumbData = child.snapshot.data['breadcrumb']
			const venueName = child.snapshot.data['venueName']

			if (breadcrumbData) {
				if (Array.isArray(breadcrumbData)) {
					for (const item of breadcrumbData) {
						if (typeof item === 'string') {
							breadcrumbs.push({ label: item, url })
						} else if (typeof item === 'object' && item.label && item.url) {
							breadcrumbs.push({ label: item.label, url: item.url })
						}
					}
				} else {
					breadcrumbs.push({ label: breadcrumbData, url })
				}
			}

			if (venueName) {
				breadcrumbs.push({ label: venueName, url })
			}

			this.buildBreadcrumbs(child, url, breadcrumbs)
		}

		return breadcrumbs
	}
}
